var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"back-link",on:{"click":_vm.navigate}},[_c('ChevronIcon',{staticClass:"back-link__icon"}),_c('span',{staticClass:"back-link__text"},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }